import classNames from 'classnames';
import Icon from 'core/modules/atoms/Icon';
import PropTypes from 'prop-types';
import React from 'react';
import './ChatCheckbox.scss';

function ChatCheckbox({ checked, onChange, label, description, disabled, className, id, name }) {
  const checkboxId = id || `chat-checkbox-${Math.random().toString(36).substr(2, 9)}`;

  const checkboxClasses = classNames(
    'chat-checkbox',
    {
      'chat-checkbox--disabled': disabled,
    },
    className
  );

  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e);
    }
  };

  return (
    <div className={checkboxClasses}>
      <label className="chat-checkbox__label" htmlFor={checkboxId}>
        <div className="chat-checkbox__input-wrapper">
          <input
            type="checkbox"
            id={checkboxId}
            name={name}
            className="chat-checkbox__input"
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
            aria-describedby={description ? `${checkboxId}-description` : undefined}
          />
          <div className="chat-checkbox__custom">{checked && <Icon type="check" className="chat-checkbox__checkmark" color="white" />}</div>
        </div>
        <div className="chat-checkbox__content">
          {label && <span className="chat-checkbox__text">{label}</span>}
          {description && (
            <span id={`${checkboxId}-description`} className="chat-checkbox__description">
              {description}
            </span>
          )}
        </div>
      </label>
    </div>
  );
}

ChatCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.node,
  description: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};

ChatCheckbox.defaultProps = {
  checked: false,
  onChange: undefined,
  label: null,
  description: null,
  disabled: false,
  className: '',
  id: undefined,
  name: undefined,
};

export default ChatCheckbox;
